import {
  TABLA_FIGURAS_SST, tamanoEmpresa, paritarioRequerido,
  type RiskLevel, type CompanySize, type FiguraSST, type ParitarioType,
} from './figuras-sst';

export type { RiskLevel, CompanySize, ParitarioType };
export type SHTRequired = FiguraSST;

export function getCompanySize(workers: number): CompanySize {
  return tamanoEmpresa(workers);
}

// DE 255 Art. 18 desde la tabla única (figuras-sst.ts). Bloque 6: la pequeña
// empresa de riesgo medio lleva monitor (antes devolvía técnico).
export function getSHTRequired(size: CompanySize, risk: RiskLevel): SHTRequired {
  return TABLA_FIGURAS_SST.find(f => f.tamano === size && f.riesgo === risk)?.figura ?? 'tecnico';
}

// Con el total de trabajadores hasta que existan las sedes (F1): el DE 255
// Arts. 32 y 33 y el AM 196 Art. 21 cuentan por lugar y/o centro de trabajo.
export function getParitarioType(workers: number): ParitarioType {
  return paritarioRequerido(workers);
}

export function getSHTLabel(sht: SHTRequired): string {
  return sht === 'monitor'
    ? 'Monitor de Seguridad e Higiene del Trabajo'
    : 'Técnico de Seguridad e Higiene del Trabajo';
}

export function getParitarioLabel(type: ParitarioType): string {
  const labels = {
    participacion_directa: 'Participación directa de todos los trabajadores (Art. 34 DE 255)',
    delegado: 'Delegado de Seguridad y Salud (Art. 33 DE 255)',
    comite: 'Comité de Seguridad y Salud — 3+3 representantes (Art. 32 DE 255)',
  };
  return labels[type];
}

export function consolidateRiskLevel(levels: RiskLevel[]): RiskLevel {
  if (levels.includes('alto')) return 'alto';
  if (levels.includes('medio')) return 'medio';
  return 'bajo';
}

export function getRiskBadgeColor(risk: RiskLevel): string {
  return { bajo: 'bg-green-100 text-green-800', medio: 'bg-yellow-100 text-yellow-800', alto: 'bg-red-100 text-red-800' }[risk];
}
